// Helpers d'affichage des véhicules dans les sélecteurs (réservation, devis).
// L'architecture métier reste Type → Catégorie → Bien ; ces helpers ne servent QUE
// à la présentation. La sélection continue d'utiliser l'identifiant technique (v.id).

// Construit les maps value -> label pour les types et catégories depuis vendor_settings.fleet
export function fleetLabelMaps(fleet) {
  const typeMap = {};
  const catMap = {};
  (fleet?.vehicle_types || []).forEach((t) => { if (t && t.value != null) typeMap[t.value] = t.label || t.value; });
  (fleet?.categories || []).forEach((c) => { if (c && c.value != null) catMap[c.value] = c.label || c.value; });
  return { typeMap, catMap };
}

// Libellé principal harmonisé d'un bien : "NUMÉRO · MARQUE MODÈLE".
// Ex. "CLIO-001 · Renault Clio". Jamais null/undefined, jamais d'identifiant technique.
export function vehiclePrimaryLabel(v = {}) {
  const ident = (v.internal_ref || v.identifier || "").toString().trim();
  const brandModel = [v.brand, v.model].filter(Boolean).join(" ").trim();
  const parts = [ident, brandModel].filter(Boolean);
  if (parts.length) return parts.join(" · ");
  return (v.name || v.internal_name || "").toString().trim() || "Véhicule";
}

// Ligne secondaire : "Type · Catégorie" (ex. "Automobile · Citadine"), ou "" si indisponible.
export function vehicleTypeCatLabel(v = {}, typeMap = {}, catMap = {}) {
  const typeName = typeMap[v.vehicle_type] || typeMap[v.type] || "";
  const catName = categoryLabel(v.category, catMap);
  return [typeName, catName].filter(Boolean).join(" · ");
}

// Libellé d'un véhicule pour un menu déroulant (une seule ligne) :
// "NUMÉRO · MARQUE MODÈLE — Type · Catégorie".
export function vehicleOptionLabel(v, typeMap = {}, catMap = {}) {
  const primary = vehiclePrimaryLabel(v);
  const sub = vehicleTypeCatLabel(v, typeMap, catMap);
  return sub ? `${primary} — ${sub}` : primary;
}

// Résout le nom métier d'une catégorie à partir de la map value->label.
// Ne renvoie jamais un identifiant technique (« cat_… ») : s'il n'est pas résolu,
// renvoie "" (badge/ligne masqué) plutôt que d'exposer l'identifiant brut.
export function categoryLabel(value, catMap = {}) {
  if (value == null || value === "") return "";
  if (catMap[value]) return catMap[value];
  if (/^cat_/i.test(String(value))) return "";
  return String(value);
}
